import clsx from 'clsx';
import type { InputHTMLAttributes, ReactNode } from 'react';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: ReactNode;
  hint?: ReactNode;
  required?: boolean;
  error?: string | null;
}

/**
 * Standard label + ts-input + hint + error.
 * required-той бол label-д улаан * автоматаар нэмэгдэнэ.
 */
export function FormField({ label, hint, required, error, className, id, ...rest }: Props) {
  const inputId = id ?? rest.name;
  return (
    <div>
      <label className="ts-form-label" htmlFor={inputId}>
        {label}
        {required ? <span className="text-red-500"> *</span> : null}
      </label>
      <input
        id={inputId}
        className={clsx('ts-input', error && 'is-invalid', className)}
        required={required}
        {...rest}
      />
      {error ? (
        <div className="if-hint if-hint-error" role="alert">
          <i className="bi bi-exclamation-circle" /> {error}
        </div>
      ) : null}
      {!error && hint ? <div className="if-hint">{hint}</div> : null}
    </div>
  );
}
